import { ErrorPageLegacy } from "./ErrorPageLegacy";
import { ErrorPageNew } from "./ErrorPageNew";
import { getTypeQuestionnaires } from "~/utils";

interface Props {
  isChunkLoadError?: boolean;
}

export const ErrorPage = ({ isChunkLoadError }: Props = {}) => {
  const isPartnerTypeQuestionnaires = getTypeQuestionnaires() === "partner";

  return !isPartnerTypeQuestionnaires ? (
    <ErrorPageNew isChunkLoadError={isChunkLoadError} />
  ) : (
    <ErrorPageLegacy isChunkLoadError={isChunkLoadError} />
  );
};
